import React, { Component } from 'react'
import axios from "axios";
import { API_BASE_URL, TYPE_SUCCESS, INTERVAL } from "assets/constants/Constants";
import { TRASH_ICON, EYE_ICON } from "assets/constants/Icons";
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';
import { hasPermission } from "components/Permission";
import Select from 'react-select';
import { defaultFormatDate, validateBitStatusAlarms } from "lib/utils"
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import MaterialTable from "material-table";

export class RouteMeterMappingPage extends Component {
    constructor(props) {
        super(props)
        const meterData = this.props.history.location.state;
        const flagVisible = this.props.history.location.state.isVisibleAddMeter ? this.props.history.location.state.isVisibleAddMeter : false;
        this.state = {
            isLoading: true,
            siteId: meterData === null ? null : meterData.rowItem.site_id,
            routeId: meterData === null ? null : meterData.rowItem._id,
            isVisibleAddMeter: flagVisible,
            routeMeterInfo: this.props.history.location.state,
            meterData,
            siteList: [],
            meterSiteData: {},
            meterList: [],
            meterDetail: [],
            error: {},
            selectedMeter: null,
            selectedAssignedMeter: null,
            meterOptions: [],
            assignedMeterOptions: [],
            searchText: ""
        }
    }

    async componentDidMount() {
        const siteData = await this.getSiteList();
        const meterData = await this.getMeterList();
        const meterDetails = await this.getMeterDetail();
        const meterSite = siteData.data.result.filter((filterItem) => filterItem._id === this.state.meterData.rowItem.site_id)[0];
        this.setState({
            siteList: siteData.data.result,
            meterList: meterData.data.result,
            meterDetail: meterDetails.data.result,
            meterSiteData: meterSite ? meterSite : {},
            isLoading: false
        }, () => {
            this.renderMeterOptions(this.state.meterList);
            this.renderAssignedMeterOptions(this.state.meterDetail)
        });
    }

    async refreshMeterList() {
        const meterData = await this.getMeterList();
        this.setState({
            meterList: meterData.data.result,
        }, () => {
            this.renderMeterOptions(this.state.meterList);
        });

    }

    async refreshAssignedMeterList() {
        const meterDetail = await this.getMeterDetail();
        this.setState({
            meterDetail: meterDetail.data.result,
        }, () => {
            this.renderAssignedMeterOptions(this.state.meterDetail);
        });

    }

    getMeterList = async () => {
        return await axios(`${API_BASE_URL}/route_meter_map/meter/notinroute/${sessionStorage.getItem("siteId")}`);
    }

    getSiteList = async () => {
        return await axios(`${API_BASE_URL}/site`);
    }

    getMeterDetail = async () => {
        return await axios(`${API_BASE_URL}/route_meter_map/route/${this.state.meterData.rowItem._id}`);
    }

    //     createMeterHandler = async (event) => {
    //     event.preventDefault();

    //     if (!this.isFormValid()) return;

    //     this.setState({ isLoading: true });

    //     const userDetails = JSON.parse(sessionStorage.getItem("userData"));
    //     const { meterId } = this.state; 

    //     // Loop through all selected meters
    //     for (let id of meterId) {
    //         const getMeterDetails = this.state.meterList.find(
    //             (meterItem) => meterItem._id === id
    //         );

    //         let serailNumber = getMeterDetails ? getMeterDetails.serial_number : "";

    //         const requestData = {
    //             meterId: id,                      // send ONE meter at a time
    //             siteId: this.state.siteId,
    //             routeId: this.state.routeId,
    //             serailNumber,
    //             userFirstName: userDetails.first_name,
    //             userLastName: userDetails.last_name,
    //             userEmailId: userDetails.email_id,
    //             userName: userDetails.username,
    //             userId: userDetails._id,
    //             reason: "Meter is added to the route",
    //             meterStatus: "Active"
    //         };

    //         // Existing API supports single meter assignment
    //         await axios.post(`${API_BASE_URL}/route_meter_map`, requestData);
    //     }

    //     // Refresh page after all meters added
    //     const meterDetails = await this.getMeterDetail();

    //     this.setState({
    //         meterDetail: meterDetails.data.result,
    //         selectedMeter: [],
    //         meterId: [],
    //     });

    //     await this.refreshMeterList();
    //     await this.refreshAssignedMeterList();

    //     ShowToast(
    //         "Meter(s) assigned successfully",
    //         TYPE_SUCCESS,
    //         INTERVAL,
    //         this.props,
    //         ""
    //     );

    //         // keep spinner till toast duration completes
    //         setTimeout(() => {
    //             this.setState({
    //                 isLoading: false
    //             });
    //         }, INTERVAL);
    // };

    createMeterHandler = async (event) => {
        event.preventDefault();

        if (!this.isFormValid()) return;

        this.setState({ isLoading: true });

        try {
            const userDetails = JSON.parse(sessionStorage.getItem("userData"));
            const { meterId, meterList, siteId, routeId } = this.state;

            const requests = meterId.map((id) => {
                const meter = meterList.find(m => m._id === id);

                return axios.post(`${API_BASE_URL}/route_meter_map`, {
                    meterId: id,
                    siteId,
                    routeId,
                    serailNumber: meter ? meter.serial_number : "",
                    userFirstName: userDetails.first_name,
                    userLastName: userDetails.last_name,
                    userEmailId: userDetails.email_id,
                    userName: userDetails.username,
                    userId: userDetails._id,
                    reason: "Meter is added to the route",
                    meterStatus: "Active"
                });
            });

            await Promise.all(requests);

            await this.refreshMeterList();
            await this.refreshAssignedMeterList();

            this.setState({
                selectedMeter: [],
                meterId: [],
                isLoading: false
            });

            ShowToast(
                "Meter(s) assigned successfully",
                TYPE_SUCCESS,
                INTERVAL,
                this.props,
                ""
            );
        } catch (error) {
            console.error(error);
            this.setState({ isLoading: false });
        }
    };


    // meterChangeHandler = (event) => {
    //     this.setState({
    //         selectedMeter: event,
    //         meterId: event.value,
    //     });
    // }

    meterChangeHandler = (selected) => {
        const filtered = this.getFilteredOptions().filter(o => o.value !== "ALL");

        if (selected.some(s => s.value === "ALL")) {
            this.setState({
                selectedMeter: filtered,
                meterId: filtered.map(m => m.value)
            });
            return;
        }

        this.setState({
            selectedMeter: selected,
            meterId: selected.map(m => m.value)
        });
    };

    assignedMeterChangeHandler = (selected) => {
        const filtered = this.getFilteredAssignedMeterOptions().filter(o => o.value !== "ALL");

        if (selected.some(s => s.value === "ALL")) {
            this.setState({
                selectedAssignedMeter: filtered,
                meterId: filtered.map(m => m.value)
            });
            return;
        }

        this.setState({
            selectedAssignedMeter: selected,
            meterId: selected.map(m => m.value)
        });
    };



    // renderMeterOptions = (meterList) => {
    //     let meterOptions = [];
    //     if(meterList.length > 0) {
    //         meterList.forEach((meterItem) => {
    //             meterOptions.push({ value: meterItem._id, label: meterItem.serial_number })
    //         });
    //     }
    //     this.setState({
    //         meterOptions
    //     });
    // }

    renderMeterOptions = (meterList) => {
        const meterOptions = meterList.map(m => ({
            value: m._id,
            label: m.serial_number
        }));

        this.setState({ meterOptions });
    };

    getFilteredOptions = () => {
        const { meterOptions, searchText } = this.state;

        // Filter by search
        const filtered = searchText
            ? meterOptions.filter(opt => opt.label.includes(searchText))
            : meterOptions;

        // Add Select All to filtered list only
        return [
            { value: "ALL", label: `Select All (${filtered.length})` },
            ...filtered
        ];
    };

    getFilteredAssignedMeterOptions = () => {
        const { assignedMeterOptions, searchText } = this.state;

        // Filter by search
        const filtered = searchText
            ? assignedMeterOptions.filter(opt => opt.label.includes(searchText))
            : assignedMeterOptions;

        // Add Select All to filtered list only
        return [
            { value: "ALL", label: `Select All (${filtered.length})` },
            ...filtered
        ];
    };

    renderAssignedMeterOptions = (meterList) => {
        const assignedMeterOptions = meterList.map(m => ({
            value: m._id,
            label: m.serial_number
        }));

        this.setState({ assignedMeterOptions });
    };

    getAssignedMeterFilteredOptions = () => {
        const { assignedMeterOptions, searchText } = this.state;

        // Filter by search
        const filtered = searchText
            ? assignedMeterOptions.filter(opt => opt.label.includes(searchText))
            : assignedMeterOptions;

        // Add Select All to filtered list only
        return [
            { value: "ALL", label: `Select All (${filtered.length})` },
            ...filtered
        ];
    };



    handleDelete = async (item) => {
        if (window.confirm("Are you sure you want to unassign this meter from route?")) {
            this.setState({ isLoading: true });

            const SerialNumber = item.serial_number;
            const userDetails = JSON.parse(sessionStorage.getItem("userData"));
            const userFirstName = userDetails.first_name;
            const userLastName = userDetails.last_name;
            const userEmailId = userDetails.email_id;
            const userName = userDetails.username;
            const userId = userDetails._id;

            const requestData = {
                siteId: this.state.siteId,
                routeId: this.state.routeId,
                SerialNumber,
                userFirstName,
                userLastName,
                userEmailId,
                userName,
                userId,
                reason: "Meter has been unassigned from route",
            }

            console.log(JSON.stringify(requestData));
            // let deleteResponse = await axios.delete(`${ API_BASE_URL }/route_meter_map/${item.map_id}`);
            let deleteResponse = await axios.post(`${API_BASE_URL}/route_meter_map/${item.map_id}`, requestData);

            if (deleteResponse.status === 200) {
                const meterDetails = await this.getMeterDetail();
                this.setState({
                    meterDetail: meterDetails.data.result,
                    selectedAssignedMeter: [],
                    meterId: [],

                    // isLoading: false
                });
                await this.refreshMeterList();
                await this.refreshAssignedMeterList();
                ShowToast('Meter unassigned from route successfully', TYPE_SUCCESS, INTERVAL, this.props, "");
                // keep spinner till toast duration completes
                setTimeout(() => {
                    this.setState({
                        isLoading: false
                    });
                }, INTERVAL);

            }
        }
    }

    handleBulkDelete = async (item) => {
        if (!this.isFormValidAssignedMeter()) return;
        const serialNumbers = item.map(meter => meter.label);
        console.log(serialNumbers);
        const meterID = item.map(meter => meter.value);
        console.log(meterID);

        if (window.confirm("Are you sure you want to unassign these meter from route?")) {
            this.setState({ isLoading: true });

            const userDetails = JSON.parse(sessionStorage.getItem("userData"));
            const userFirstName = userDetails.first_name;
            const userLastName = userDetails.last_name;
            const userEmailId = userDetails.email_id;
            const userName = userDetails.username;
            const userId = userDetails._id;

            const requestData = {
                siteId: this.state.siteId,
                routeId: this.state.routeId,
                serialNumbers,
                userFirstName,
                userLastName,
                userEmailId,
                userName,
                userId,
                reason: "Meter has been unassigned from route",
            }

            console.log(JSON.stringify(requestData));
            // let deleteResponse = await axios.delete(`${ API_BASE_URL }/route_meter_map/${item.map_id}`);
            let deleteResponse = await axios.post(`${API_BASE_URL}/bulk/route_meter_map/${meterID}`, requestData);

            if (deleteResponse.status === 200) {
                const meterDetails = await this.getMeterDetail();
                this.setState({
                    meterDetail: meterDetails.data.result,
                    selectedAssignedMeter: [],
                    meterId: [],
                    // isLoading: false
                });
                await this.refreshMeterList();
                await this.refreshAssignedMeterList();
                ShowToast('Meter unassigned from route successfully', TYPE_SUCCESS, INTERVAL, this.props, "");
                // keep spinner till toast duration completes
                setTimeout(() => {
                    this.setState({
                        isLoading: false
                    });
                }, INTERVAL);
            }
        }
    }

    isFormValid = () => {
        let isValid = true;
        let error = {};
        if (!this.state.meterId || this.state.meterId.length === 0) {
            isValid = false;
            error.meterId = "Please select meter";
        }
        if (this.state.meterId !== undefined && this.state.meterId === "0" && this.state.meterId) {
            isValid = false;
            error.meterId = "Please select meter";
        }

        this.setState({
            error
        });
        return isValid;
    }

    isFormValidAssignedMeter = () => {
        let isValid = true;
        let error = {};
        if (!this.state.selectedAssignedMeter || this.state.selectedAssignedMeter.length === 0) {
            isValid = false;
            error.selectedAssignedMeter = "Please select assigne meter";
        }

        this.setState({
            error
        });
        return isValid;
    }

    showMeterReadingHandler = (routeItem) => {
        if (this.state.routeMeterInfo.pageName === "Route Master") {
            this.props.history.push({
                pathname: "/meter-reading",
                state: {
                    routeItem,
                    pageName1: "Route Meter Mapping",
                    pathName1: "route-meter-mapping",
                    pageName: "Route Master",
                    pathName: "master-route-page",
                }
            });
        }
        else if (this.state.routeMeterInfo.pageName === "Route Transaction") {
            this.props.history.push({
                pathname: "/meter-reading",
                state: {
                    routeItem,
                    pageName1: "Route Meter Mapping",
                    pathName1: "route-meter-mapping",
                    pageName: "Route Transaction",
                    pathName: "route-transaction-page",
                }
            });
        }
        else {
            this.props.history.push({
                pathname: "/meter-reading",
                state: {
                    routeItem,
                    pageName1: "Route Meter Mapping",
                    pathName1: "route-meter-mapping",
                    pageName: "Route Collection History",
                    pathName: "route-history",
                }
            });
        }
    }

    render() {
        if (this.state.isLoading) {
            return (
                <Spinner />
            )
        }
        else {
            return (
                <div className="main-content">
                    <div className="back">
                        <ul className="breadcrumb1">
                            {
                                this.state.routeMeterInfo.pageName1 === "Route Meter Mapping" ? (
                                    <>
                                        <li><a href={this.state.routeMeterInfo.pathName}>{this.state.routeMeterInfo.pageName}</a></li>
                                        <li>Route Meter Mapping</li>
                                    </>
                                ) : (
                                    <>
                                        <li><a href={this.state.routeMeterInfo.pathName}>{this.state.routeMeterInfo.pageName}</a></li>
                                        <li>Route Meter Mapping</li>
                                    </>
                                )
                            }

                        </ul>
                    </div>
                    <div className="reading-info-outer">
                        <div className="reading-wrapper">
                            <div className="site-wrapper">
                                <div className="row">
                                    <div className="site-info">
                                        <div className="site-content">
                                            <label>Site Name: </label>
                                            <label className="ml-3">{this.state.meterSiteData.site_name}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="site-info">
                                        <div className="content">
                                            <label>Site Address: </label>
                                            <label className="ml-3">{`${this.state.meterSiteData.street}, ${this.state.meterSiteData.city}, ${this.state.meterSiteData.pincode}`}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="customer-wrapper">
                                <div className="row">
                                    <div className="cust-info">
                                        <div className="site-content">
                                            <label>Route Name: </label>
                                            <label className="ml-3">{this.state.meterData.rowItem.route_name}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="site-info">
                                        <div className="content">
                                            <label>Address: </label>
                                            <label className="ml-3">{`${this.state.meterData.rowItem.street}, ${this.state.meterData.rowItem.city}, ${this.state.meterData.rowItem.pin_code}`}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        (this.state.meterDetail.length > 0 && this.state.isVisibleAddMeter === false) && (
                            <div className="addButton">
                                <ReactHTMLTableToExcel
                                    id="test-table-xls-button"
                                    className="download-table-xls-button brandxls-button download-button xls-btn"
                                    table="table-to-xls"
                                    filename={this.state.meterData.rowItem.route_name}
                                    sheet="tablexls"
                                    buttonText="Download as XLS" />
                            </div>
                        )
                    }

                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                        {
                            this.state.meterDetail.length > 0 ? (

                                <MaterialTable
                                    title="Meter Details"

                                    columns={[
                                        {
                                            title: "Serial Number",
                                            field: "serialNumber",
                                            cellStyle: { width: "15%", fontWeight: "bolder", color: "#000", fontSize: 14 }
                                        },
                                        {
                                            title: "Meter Type",
                                            field: "meterType",
                                            sorting: false,
                                            cellStyle: { width: "15%", color: "#808080", fontSize: 14 }
                                        },
                                        {
                                            title: "Last Updated Reading",
                                            field: "lastUpdatedReading",
                                            cellStyle: { width: "14%", color: "#808080", fontSize: 14 }
                                        },
                                        {
                                            title: "Updated Reading Date",
                                            field: "updatedReadingDate",
                                            cellStyle: { width: "14%", color: "#808080", fontSize: 14 }
                                        },
                                        {
                                            title: "Unit",
                                            field: "unit",
                                            cellStyle: { width: "10%", color: "#808080", fontSize: 14 }
                                        },
                                        {
                                            title: "Meter Status",
                                            field: "meterStatusHtml",
                                            sorting: false,
                                            cellStyle: { width: "12%", color: "#808080", fontSize: 14 }
                                        },
                                        {
                                            title: "Alarms",
                                            field: "alarms",
                                            cellStyle: {
                                                width: "14%",
                                                maxWidth: 100,
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                color: "#808080",
                                                fontSize: 14
                                            }
                                        },
                                        {
                                            title: "Consumer Number",
                                            field: "consumerNumber",
                                            cellStyle: { width: "14%", color: "#808080", fontSize: 14 }
                                        }
                                    ]}

                                    data={
                                        this.state.meterDetail.map(item => {
                                            let meterStatusClass = "text-warning";
                                            if (item.status?.toLowerCase() === "active") meterStatusClass = "text-success";
                                            else if (item.status?.toLowerCase() === "faulty") meterStatusClass = "text-danger";
                                            else if (item.status?.toLowerCase() === "inactive") meterStatusClass = "text-warning";

                                            let unitValue = "NA";
                                            if (item.unit !== null) {
                                                unitValue =
                                                    item.unit === "0" || item.unit === "m3" ? "m3" :
                                                        item.unit === "1" || item.unit === "L" ? "L" :
                                                            item.unit === "2" || item.unit === "GAL" ? "GAL" :
                                                                item.unit === "3" || item.unit === "ft3" ? "ft3" : "NA";
                                            }

                                            return {
                                                _id: item._id,
                                                serialNumber: item.serial_number,
                                                meterType: item.meter_type,
                                                lastUpdatedReading: item.last_updated_reading || "NA",
                                                updatedReadingDate: item.last_update_date ? defaultFormatDate(item.last_update_date) : "NA",
                                                unit: unitValue,
                                                meterStatusHtml: <span className={`${meterStatusClass}`}>{item.status}</span>,
                                                alarms: item.alarms ? validateBitStatusAlarms(item.alarms) : "None",
                                                consumerNumber: item.consumer_no || "None",
                                                rawItem: item
                                            };
                                        })
                                    }


                                    actions={[
                                        {
                                            icon: () => <i className={hasPermission("meter", "delete") ? `${TRASH_ICON}` : "not-active"}></i>,
                                            onClick: (event, rowData) =>
                                                hasPermission("meter", "delete") ? this.handleDelete(rowData.rawItem) : ""
                                        },
                                        {
                                            icon: () => <i className={hasPermission("meter", "read") ? `${EYE_ICON}` : "not-active"}></i>,
                                            onClick: (event, rowData) =>
                                                hasPermission("meter", "read") ? this.showMeterReadingHandler(rowData.rawItem) : ""
                                        }

                                    ]}

                                    options={{
                                        actionsColumnIndex: -1,
                                        pageSize: 10,
                                        pageSizeOptions: [10, 20, 50, 100],
                                        filtering: false,
                                        sorting: true,
                                        exportButton: true,
                                        exportAllData: true,
                                        exportFileName: "Meter Details",
                                        headerStyle: {
                                            color: "#999998",
                                            fontWeight: "bolder",
                                            fontSize: 15
                                        }
                                    }}

                                    onRowClick={(event, rowData) =>
                                        this.showMeterReadingHandler(rowData.rawItem)
                                    }

                                />

                            ) : (
                                <div className="text-center pt-2">No Records Found!</div>
                            )
                        }
                    </div>

                    <div className="list-wrapper">
                        {
                            hasPermission("meter", "create") && this.state.isVisibleAddMeter === true && (
                                <>
                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                                        <div className="row">
                                            <div className="AddMeter">
                                                <label className="form-label"> Assign Meter  <span className="text-danger">*</span></label>
                                                <Select
                                                    placeholder={'Select Meter'}
                                                    value={this.state.selectedMeter}
                                                    onChange={this.meterChangeHandler}
                                                    onInputChange={(value) => this.setState({ searchText: value })}
                                                    // options={this.state.meterOptions}
                                                    options={this.getFilteredOptions()}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    filterOption={() => true}
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.meterId}
                                                </div>
                                            </div>

                                            <div className="AddButton">
                                                <button className="brand-button" onClick={this.createMeterHandler}>Add Meter</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                                        <div className="row">
                                            <div className="AddMeter">
                                                <label className="form-label"> Unassign Meter  <span className="text-danger">*</span></label>
                                                <Select
                                                    placeholder={'Select Meter'}
                                                    value={this.state.selectedAssignedMeter}
                                                    onChange={this.assignedMeterChangeHandler}
                                                    onInputChange={(value) => this.setState({ searchText: value })}
                                                    // options={this.state.meterOptions}
                                                    options={this.getAssignedMeterFilteredOptions()}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    filterOption={() => true}
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.selectedAssignedMeter}
                                                </div>
                                            </div>

                                            <div className="AddButton">
                                                <button className="brand-button" onClick={() => this.handleBulkDelete(this.state.selectedAssignedMeter)}>Remove Meter</button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            )
        }
    }

}

export default RouteMeterMappingPage